import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";
import { keyBy } from "lodash-es";

import { PageAction } from "./page.action";
import { PageState } from "./page.model";

const INITIAL_STATE: PageState = {
	pages: {},
	current: undefined,
};

export const pageReducer = createReducer(
	INITIAL_STATE,
	on(PageAction.setCurrent, (state, { payload }) => {
		const parentPages = keyBy(payload.parentPages, (page) => page.documentKey);
		return updateState(state, {
			pages: {
				...state.pages,
				...parentPages,
				[payload.page.documentKey]: payload.page,
			},
			current: payload.page,
		});
	}),
	on(PageAction.getByKeySuccess, (state, { payload }) => {
		const parentPages = keyBy(payload.parentPages, (page) => page.documentKey);
		return updateState(state, {
			pages: {
				...state.pages,
				...parentPages,
				[payload.page.documentKey]: payload.page,
			},
		});
	})
);
